<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        
        <v-row class="pa-0 px-4">
          <v-col cols="12" class="pa-5">
            <dashboardSlider :images="images" />
          </v-col>
          <v-col cols="12" LOADING v-if="loading" class="pa-0 ma-0">
            <v-dialog v-model="loading" persistent max-width="450">
              <v-card color="primary" class="pa-3">
                <v-progress-linear color="white" v-if="loading" :indeterminate="true"></v-progress-linear>
              </v-card>
            </v-dialog>
            <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
          </v-col>
          <v-col cols="12" LOADING class="py-0 my-0" v-if="!loading">
            <OnBoarding :loading="loading" @snackbarNotification="sendSnackbarNotification" />
            <Enforce :loading="loading" @snackbarNotification="sendSnackbarNotification" />
          </v-col>
          <v-col cols="12" LOADING class="py-0 my-0" v-if="!loading">
            <Verification :loading="loading" @snackbarNotification="sendSnackbarNotification" />
          </v-col>
          <v-col cols="12" LOADING class="py-0 my-0" v-if="!loading">
            <VerificationEmail :loading="loading" @snackbarNotification="sendSnackbarNotification" />
          </v-col>
          <v-col cols="12" FLAG-COUNTRY-PICKER class="pt-0 mt-0">
            <v-row class="px-5 text-center">
              <v-col cols="12" :class="`${arabic?'arFont':'enFont'} pa-5 text-center`" style="font-size:22px;">
                {{ i18n['choose_country_to_show_products'] }}
              </v-col>
              <v-item-group v-model="selectedCountryId" class="text-center" dense>
                <v-item
                  v-for="(country, c) in countries" :key="'country-' +c"
                  v-slot="{ active, toggle }"
                  class="text-center"
                >
                  
                  <v-btn 
                    active-class="biggerPix"
                    :input-value="active"
                    label 
                    class="flagBtn ma-1"
                    @click="toggle"
                    link
                    :loading="loading"
                    text
                    :value="country"
                    style="text-transform:uppercase;" 
                    :disabled="soon(country.alpha2Code.toLowerCase())"
                    dark 
                    color="primary">
                    <v-badge
                      bordered
                      overlap
                      tile
                    >
                    <template v-slot:badge>
                      <div v-if="soon(country.alpha2Code.toLowerCase())" :class="`${arabic ? 'arFont' : 'enFont'}`"> {{i18n["soon"]}} </div>
                    </template>
                      <img width="53px" style="filter:drop-shadow(2px 2px 4px rgb(0 0 0 / 38%));" :src="`/flags/${country.alpha2Code.toLowerCase()}.png`" alt="">
                    </v-badge>
                      <span :class="`${arabic?'arFont':'enFont'} primary--text`">{{countries_[language][country.alpha2Code.toLowerCase()]}}</span>
                  </v-btn>
                </v-item>
              </v-item-group>
              <v-col cols="1" class="pa-2" v-for="(country, c) in 0" :key="'country-' +c">
                <img width="100%" style="filter:drop-shadow(2px 2px 4px rgb(0 0 0 / 38%));" :src="`/flags/${country.alpha2Code.toLowerCase()}.png`" alt="">
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0" v-if="all_products.data && all_products.data.length">
            <v-row class="pa-0">
              <v-col cols="12" md="12" class="pa-2 pr-4 mt-0 primary flash_sale_class" v-if="!$vuetify.breakpoint.xsOnly">
                <v-row>
                  <v-col cols="12" md="4" :class="`${arabic ? 'arFont text-right' : 'enFont text-left'} py-0`">
                    <img :src="`/images/fsale/offer_ninja_${language}.png`" height="61px" alt="">
                  </v-col>
                  <v-col cols="12" md="5" class="text-center py-0">
                    <img src="/images/fsale/flash_offer_center.png" height="60px" alt="">
                  </v-col>
                  <v-col cols="12" md="3" class="py-0 align-center">
                    <v-btn color="primary" dark :disabled="checkDisable(flash_products)" small :class="`${arabic ? 'arFont text-left' : 'enFont text-right'} `" @click="goTo(`/category/flash_products`)">
                      {{ i18n["show_all_offers"] }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="12" class="pa-2 pr-4 mt-0 primary flash_sale_class" v-if="$vuetify.breakpoint.xsOnly">
                  <v-row>
                    <v-col cols="12" md="6" :class="`${arabic ? 'arFont text-right' : 'enFont text-left'} py-0`">
                      <img :src="`/images/fsale/offer_ninja_${language}.png`" height="60px" alt="">
                    </v-col>
                    <v-col cols="12" md="6" class="text-center py-0">
                      <img src="/images/fsale/flash_offer_center.png" height="60px" alt="">
                    </v-col>
                    <v-col cols="12" md="12" class="py-0 align-center text-center">
                      <v-btn color="primary" dark :disabled="checkDisable(flash_products)" small :class="`${arabic ? 'arFont text-left' : 'enFont text-right'} `" @click="goTo(`/category/flash_products`)">
                        {{ i18n["show_all_offers"] }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              <v-col cols="12" md="6" class="pa-2 ${$vuetify.breakpoint.xsOnly ? 'pt-6 text-center' : 'py-6'} pr-4 mt-0" style="background:#ff9800;" v-if="false">
                <span :class="`${arabic?'arFont':'enFont'} white--text`" style="font-size:18px;font-weight:bold;"><v-icon class="pl-4" color="primary">sell</v-icon>
                  {{ i18n["flash_offers"] }}
                </span>
              </v-col>
              <v-col cols="12" md="6" :class="`pa-2 ${$vuetify.breakpoint.xsOnly ? 'pb-3  text-center' : 'py-6'} mt-0 ${arabic ? 'text-left' : 'text-right'} white-text`" style="background:#ff9800;" v-if="false">
                <v-btn color="primary" :disabled="checkDisable(flash_products)" small :class="`${arabic?'arFont':'enFont'}`" @click="goTo(`/category/flash_products`)">
                  {{ i18n["show_all_offers"] }}
                </v-btn>
              </v-col>
              <v-col cols="12" md="12" class="pa-1 py-4 elevation-3 text-center">
                <h1 v-if="checkDisable(flash_products)" :class="`${arabic?'arFont':'enFont'}`">
                  {{ i18n["wait_for_best_offers"] }}
                </h1>
                <h1 v-if="checkDisable(flash_products)" :class="`${arabic?'arFont':'enFont'}`">{{ i18n['soon'] }}....</h1>
                <productSlider v-if="flash_products && flash_products.data && flash_products.data.length" @reload="loadHome" :products="flash_products.data" :loading="loading" />
              </v-col>
              <v-col cols="12" md="6" class="pa-2 mt-5">
                <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;font-weight:bold;">
                  {{ i18n["best_selling_products"] }}
                </div>
              </v-col>
              <v-col cols="12" md="6" :class="`pa-2 mt-5 ${arabic ? 'text-left' : 'text-right'}`">
                <v-btn color="primary" small :class="`${arabic?'arFont':'enFont'}`" @click="goTo(`/category/best_sellers`)">
                  {{ i18n["show_all_best_sellers"] }}
                </v-btn>
              </v-col>
              <v-col cols="12" md="12" class="pa-1" v-if="false">
                <productSlider @reload="loadHome" :products="best_sellers.data" :loading="loading" />
              </v-col>
              <v-col cols="12" md="12" class="pa-1">
                <v-row>
                  <v-col cols="12" md="3" class="pa-1" v-for="(product, i) in best_sellers.data" :key="i+'best_seller'">
                    <Product
                      @reload="reload" 
                      :class="`${arabic? 'revDirection' :''}`" 
                      :loading="loading" 
                      :i="i" 
                      :product="product" />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6" class="pa-2 mt-5">
                <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;font-weight:bold;">
                  {{ i18n["latest_products"] }}
                </div>
              </v-col>
              <v-col cols="12" md="6" :class="`pa-2 mt-5 ${arabic?'text-left':'text-right'}`">
                <v-btn color="primary" small :class="`${arabic?'arFont':'enFont'}`" @click="goTo(`/category/new_products`)">
                  {{ i18n["show_all_latest_products"] }}
                </v-btn>
              </v-col>
              <v-col cols="12" md="12" class="pa-1" v-if="false">
                <productSlider @reload="loadHome" :products="new_products.data" :loading="loading" />
              </v-col>
              <v-col cols="12" md="12" class="pa-1">
                <v-row>
                  <v-col cols="12" md="3" class="pa-1" v-for="(product, i) in new_products.data" :key="i+'new_product'">
                    <Product @reload="reload" :class="`${arabic? 'revDirection' :''}`" :loading="loading" :i="i" :product="product" />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6" class="pa-2 mt-5">
                <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;font-weight:bold;">
                  {{ i18n["all_products"] }}
                </div>
              </v-col>
              <v-col cols="12" md="6" :class="`pa-2 mt-5 ${arabic ? 'text-left' : 'text-right'}`">
                <v-btn color="primary" small :class="`${arabic?'arFont':'enFont'}`" @click="goTo(`/category/all`)">
                  {{ i18n['show_all_products'] }}
                </v-btn>
              </v-col>
              <v-col cols="12" md="12" class="pa-1" v-if="false">
                <productSlider @reload="loadHome" :products="all_products.data" :loading="loading" />
              </v-col>
              <v-col cols="12" md="12" class="pa-1">
                <v-row>
                  <v-col cols="12" md="3" class="pa-1" v-for="(product, i) in all_products.data" :key="i+'all_product'">
                    <Product @reload="reload" :class="`${arabic? 'revDirection' :''}`" :loading="loading" :i="i" :product="product" />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="12" class="pa-1" v-if="false">
                <productSlider @reload="loadHome" :products="special_products.data" :loading="loading" />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0" v-if="!loading && (!all_products.data || !all_products.data.length)">
            <img :src="`/images/ship/${language}_mobile.png`" v-if="$vuetify.breakpoint.xsOnly" alt="" width="100%">
            <img :src="`/images/ship/${language}_pc.png`" v-else alt="" width="100%">
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog"  max-width="500px" :class="`${arabic?'arFont':'enFont'} `">
      <v-card>
        <v-card-title>
          <span style="margin-bottom: 20px;" class="headline" :class="`${arabic?'arFont':'enFont'} `" >{{ arabic ? 'تنبيه' : 'Alert' }} </span>
        </v-card-title>
        <v-card-subtitle>
          <p  :class="`${arabic?'arFont':'enFont'} `">{{ arabic ? 'يوجد لديك طلبات لما ترسل الى منصة نينجا ' : 'You have requests when sending to NinjaSellers platform.' }}</p>
        </v-card-subtitle>
        <v-card-subtitle  :class="`${arabic?'arFont':'enFont'} `">
          {{ arabic ? ' لقد تجاوزت الحد المسموح لرفع الطلبات  لهذه الخطة يرجى ترقية الخطة ' : 'You have exceeded the allowed limit for submitting requests for this plan. Please upgrade your plan.' }}
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary"  @click="closePopupSubscription(); dialog = false"  :class="{'arFont': arabic, 'enFont': !arabic}" > {{ i18n['close'] }}</v-btn>

          <v-btn color="success"  :class="{'arFont': arabic, 'enFont': !arabic}"   @click="navigateToPlanPrice">  {{ arabic ? 'ترقية الخطة' : 'Plan Upgrade' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Product from '@/components/Product'
import productSlider from '@/components/productSlider';
import dashboardSlider from '@/components/dashboardSlider'
import Paging from '@/components/Paging'
import ChangeCountry from '@/components/ChangeCountry'
import Verification from '@/components/Verification'
import VerificationEmail from '@/components/VerificationEmail'
import OnBoarding from '@/components/OnBoarding'
import Enforce from '@/components/Enforce'
import introJs from 'intro.js/intro.js';
import "intro.js/minified/introjs.min.css";
import * as style from 'intro.js/introjs-rtl.css';

import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: {Product, Paging, ChangeCountry, dashboardSlider, productSlider, Verification, VerificationEmail, OnBoarding, Enforce},
  data() {
    return {
      loading:false,
      dialog: false,  // Controls the visibility of the dialog
      notificationData: '',  // Stores the data for the dialog
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        
      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:false,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      firstPanel:true,
      secondPanel:false,
      thirdPanel:false,
      menu1:false,
      fromDate:null,
      menu2:false,
      toDate:null,
      statuses:[],
      selectedStatus:null,
      selectedCountry:null,
      selectedCategory:[],
      selectedCountryId:52,
      page:1,
      images:[
        {url:'/arjobanner.gif'},
        {url:'/arjobanner.gif'},
        {url:'/arjobanner.gif'},
      ],
      
      countries:[],
      new_products:[],
      best_sellers:[],
      special_products:[],
      all_products:[],
      cached_country:false,
      flash_products:[],
    }
  },
  methods: {
    navigateToPlanPrice() {
          this.$router.push({ name: 'plan_price' });
        },

        

        async closePopupSubscription() {
      try {
        const response = await this.$store.dispatch('getResource', { resource: '/closePopupSubscription' });
        console.log("close_popup", response);
      } catch (error) {
        console.error('Error Close popup', error);
      }
    },
    async SubscriptionNotification() {
      try {
        const response = await this.$store.dispatch('getResource', { resource: '/popupSubscription' });
        console.log("data_notification", response);
        this.notificationData = response;  // Set the response data
        if(this.notificationData.status=="limit_form_submission"){
        this.dialog = true;  // Show the dialog
        }
      } catch (error) {
        console.error('Error fetching notification data:', error);
      }
    },
    soon(str) {
      return this.soon_countries.includes(str)
    },
    checkDisable(item){
      return !item || !item.data || !item.data.length
    },
    async sendSnackbarNotification(msg, type){
        this.$emit('snackbarNotification', msg, type)
    },
    async manualCountry() {
      this.loading = true
      const bid = this.$store.state.country.id
      await this.$store.dispatch('manualCountry', this.selectedCountry)
      if(bid != this.selectedCountry.id) {
        await this.loadHome()
      }
      this.loading = false
      this.countryDialog()
    },
    countryDialog(){
      this.$store.state.country_dialog = false
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        this.page = n
        if(!this.search){
          // console.log(this.buildFilter())
          this.resource = await this.$store.dispatch('load_products', {resource:this.$route.path, page:`?page=${n}` + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
      })
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    buildFilter(){
      let filter = ``
      // console.log(this.selectedCategory)
      if(this.selectedCategory.length) {
        filter += `&filter[category]=${this.selectedCategory.join(',')}`
      }
      return filter
    },
    async filterResources(){
      await this.loadResource()
    },
    firstLoad(){
      if(this.user) {
      }
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          // console.log(this.page)
          this.resource = await this.$store.dispatch('load_products', {page:`?page=${this.page}` + this.buildFilter()})
          // console.log(this.resource)
        } else {
          this.resource = await this.$store.dispatch('searchProducts', {resource:this.$route.path + '/search', value:this.search})
        }
        this.loading = false
        res()
      })
    },
    filterResources() {
      this.loadResource()
    },
    showPannel(v){
      this[v] = true
      let all = this.subitems.map(x=>x.value)
      all.filter(x=>x!=v).forEach(x=>this[x] = false)
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')]
    },
    favPricing(products) {
      let state = this.$store.state
      let favs = this.favs.map(x=>x.product_id)
      if (!products || !products.length) return;
      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        products[i].active_image = products[i].image

        if(favs.includes(product.id)){
          product.fav = true
        } else {
          product.fav = false
        }
        let f = product.vprices.filter(x=> x.country && ( x.country.name == 'ALL' || x.country.id ==  state.country.id))
        if(f.length) {
          product.price_name = f[0].name
          product.base_price = parseFloat((parseFloat(f[0].value)).toFixed(2))
          product.price = parseFloat((parseFloat(f[0].value) * state.currency_factor).toFixed(1))
          product.base_profit = parseFloat((parseFloat(f[0].value) * 0.2).toFixed(2))
          product.profit = parseFloat((parseFloat(f[0].value) * state.currency_factor * 0.2).toFixed(1))
          product.user_base_profit = parseFloat((parseFloat(f[0].value) * 0.2).toFixed(2))
          product.user_profit = parseFloat((parseFloat(f[0].value) * state.currency_factor * 0.2).toFixed(1))
          product.currency_factor = state.currency_factor
          if(f[0] && f[0].flash_item) {
            product.before_flash_price = parseFloat((parseFloat(f[0].before_flash_price) * state.currency_factor).toFixed(8))
            product.flash_item = true
            product.flash_hours = f[0].flash_hours
            product.flash_price = parseFloat((parseFloat(f[0].flash_price) * state.currency_factor).toFixed(8))
            product.flash_start = f[0].flash_start
            product.flash_end = f[0].flash_end
            product.flash_start_hours = f[0].flash_start_hours
            product.delayed_flash = f[0].delayed_flash
            product.start_remaining = f[0].start_remaining
            product.end_remaining = f[0].end_remaining
            product.remaining_hours = f[0].remaining_hours

          }
          // if(state.tax) {
          //   product.price = parseFloat((parseFloat(product.price) + product.price * state.tax).toFixed(1))
          // }
        }
        let c = product.remaining.filter(x=> x.country_id ==  state.country.id)
        // console.log(state.country.id, product, c)
        if(c.length) {
          product.count = c[0].count
        }
      }
      return products
    },
    initIntro(){
      introJs().setOptions({
        steps: [
        {
          element: document.querySelector('.academy-link'),
          intro: this.i18n.academyIntroTooltip,
        }],
        doneLabel: this.i18n.closeBtn,
        showStepNumbers:false,
        showBullets:false,
        overlayOpacity:0.6,
        highlightClass:'custom-intro-highlight',
        tooltipClass:'custom-intro-tooltip'  
        }).start();
    },
    async finsihOnBoarding() {
      await this.$store.dispatch('getResource', { resource: '/user/endboarding' });
      this.$store.state.user = await this.$store.dispatch('getUser')
    },

    async loadHome() {
      return new Promise(async (res, rej)=>{
     
        this.loading = true
        let cc = 'JO'
        if(!localStorage.country || !JSON.parse(localStorage.country) || !JSON.parse(localStorage.country).alpha2Code) {
          localStorage.removeItem('country');
        }
        let stored_country = localStorage.country && localStorage.country != null ? JSON.parse(localStorage.country) : null
        if(stored_country) {
          console.log('there is a stored country')
          this.$store.state.country = stored_country
          this.$store.dispatch('manualCountry', stored_country)
          cc = stored_country.alpha2Code
          this.cached_country = true
        }
        this.$store.dispatch('getFavs')
        console.log('account_id', this.user.account.id)
        let home = await this.$store.dispatch('getBackResource', {resource:`/ninja/${cc}/${this.user.account.id}` + this.buildFilter()})
        this.countries = home.countries
        if(!stored_country) {
          console.log('there is no stored country', home.country)
          this.$store.state.country = home.country
          this.$store.dispatch('manualCountry', home.country)
          localStorage.country = JSON.stringify(this.selectedCountry)
        }
        
        home.new_products.data = this.favPricing(home.new_products.data)
        home.best_sellers.data = this.favPricing(home.best_sellers.data)
        home.all_products.data = this.favPricing(home.all_products.data)
        home.flash_products.data = this.favPricing(home.flash_products.data)
        this.flash_products = home.flash_products
        console.log('flash', this.flash_products)
        this.new_products = home.new_products
        this.best_sellers = home.best_sellers
        this.special_products = home.special_products
        this.all_products = home.all_products
        // console.log('home data', home)
        this.resource = home
        
        this.loading = false
        res()
      })
    },
    reload(){}
  },
  computed:{
    soon_countries() {
      return this.$store.state.soon_countries
    },
    countries_() {
      return this.$store.state.countries_
    },
    favs(){
      return this.$store.state.favs
    },
    cc(){
      return this.$store.state.cc
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
    // countries(){
    //   return this.$store.state.countries
    // },
    country(){
      return this.$store.state.country
    },
  },
  watch:{
    selectedCountryId(){
      // console.log('selected country', this.selectedCountry, this.countries)

      this.selectedCountry = this.countries[this.selectedCountryId]
    },
    selectedCountry(){
      localStorage.country = JSON.stringify(this.selectedCountry)
      this.manualCountry()
    }
  },
  async created(){
    this.SubscriptionNotification()
    this.setResourceName()
    await this.loadHome()
  },
  async mounted(){
    this.$store.state.user = await this.$store.dispatch('getUser')
    if (this.user && this.user.id && this.user.onboarding === 1 &&  this.user.onboarding_step == 3) {
        this.initIntro();
        this.finsihOnBoarding()
      }
  }
}
</script>

<style >
.flagBtn {
  height: 80px !important;
}
.custom-intro-highlight{
  background: transparent;
  border: 1px solid white;
  backdrop-filter: brightness(230%);
}
.introjs-tooltip{
min-width: 170px !important;
}
.custom-intro-tooltip{
  line-height: 25px;
}
.introjs-skipbutton{
  background-color: white !important;
  border: 1px solid #be202e;
  color: #be202e;
  background-image: none;
  padding: 5px 20px;
  border-radius: 5px;
  font-size: 13px;
}

.flash_sale_class {
  background-image: url('/images/fsale/pattern_flash_sale.png'); /* Replace with your image path */
  background-repeat: repeat; /* This will tile your image */
  background-size: 400px 270px; /* Adjust these values to make the pattern smaller */
}
</style>